"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseTranslation = require("nicbase-translation");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var TourDataViewHeader = function TourDataViewHeader(_ref) {
  var name = _ref.name,
      image = _ref.image;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col justify-center items-center lg:flex-row lg:justify-between bg-white py-4"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    href: "https://nic-place.com",
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.NicplaceLogo, {
    className: "h-8 w-auto lg:ml-24 bg-white"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-24 mt-4 lg:mt-0 lg:mr-12",
    title: "Logo"
  }, image ? /*#__PURE__*/_react["default"].createElement("img", {
    src: "".concat(ENV.imageStoreBaseUrl, "/image/").concat(image, "/company.png"),
    alt: "Company Logo"
  }) : null)), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.tour"
  }, function (value) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "p-8 lg:pl-24 pb-4 text-3xl font-bold text-primary bg-gray-100"
    }, value, ": ", name);
  }));
};

TourDataViewHeader.propTypes = {
  image: _propTypes["default"].string,
  name: _propTypes["default"].string
};
TourDataViewHeader.defaultProps = {
  image: '',
  name: ''
};
var _default = TourDataViewHeader;
exports["default"] = _default;